import { Controller } from "@hotwired/stimulus"
import { setTransitionOpen } from "../helpers/transition"

export default class extends Controller {
  static values = {
    autoDismiss: Boolean
  }

  connect() {
    if (this.autoDismissValue) {
      this.timeout = setTimeout(() => this.dismiss(), 5000)
    }
  }

  disconnect() {
    clearTimeout(this.timeout)
  }

  close(e) {
    e.stopPropagation()
    e.preventDefault()
    this.dismiss()
  }

  dismiss() {
    setTransitionOpen(this.element, false)
  }
}
